import React from 'react';
import { motion } from 'framer-motion';

function RelationshipsSection() {
  const relationshipData = [
    {
      key: 'banking',
      title: "The Craft of Relationship Banking",
      description: "Our relationship promise to all our customers is that you will deal directly with the decision maker. We won't just look at your credit scores, assets or security. Our experienced relationship bankers have the expertise to see and understand your business's opportunities and potential.",
      image: "/new-assets/pexels-felicity-tai-7964412.jpg"
    },
    {
      key: 'growth',
      title: "Grow Your Assets with Retail Investors",
      description: "We are on the cusp of a paradigm shift in terms of retail's role in a historically institutional dominated investment landscape. With Blockfirst Capital consulting, you can access the retail market effortlessly. Retail capital is sticky, distributed, and growing fast.",
      image: "/new-assets/pexels-thirdman-7652135.jpg"
    },
    {
      key: 'loyalty',
      title: "Loyal Clients",
      description: "Our client base remains invested with high retention due to our network of unique investment products, ongoing educational tools, and technology infrastructure. Our separately-managed account (SMA) platform is not reliant on any single investor.",
      image: "/new-assets/pexels-vlada-karpovich-7433874.jpg"
    }
  ];

  const renderIcon = (key) => {
    const common = { width: 20, height: 20, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round', className: 'text-white' };
    switch (key) {
      case 'banking':
        // Handshake
        return (
          <svg {...common}>
            <path d="M11 17h4a2 2 0 1 1 0 4h-4v-4z" />
            <path d="M13 13h-4a2 2 0 1 1 0-4h4v4z" />
            <path d="M12 12h.01" />
            <path d="M12 20h.01" />
          </svg>
        );
      case 'growth':
        // Trending up
        return (
          <svg {...common}>
            <path d="M22 7L13.5 15.5L8.5 10.5L2 17" />
            <path d="M16 7h6v6" />
          </svg>
        );
      case 'loyalty':
      default:
        // Award
        return (
          <svg {...common}>
            <path d="M6 9l6 6 6-6" />
            <path d="M12 3v18" />
            <circle cx="12" cy="12" r="10" />
          </svg>
        );
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div
          data-aos="fade-up"
          data-aos-delay="100"
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-semibold text-gray-900 mb-4">Building Lasting Relationships</h2>
        </div>

        <div className="space-y-20">
          {relationshipData.map((item, index) => (
            <div
              key={item.title}
              data-aos="fade-up"
              data-aos-delay={`${200 + index * 200}`}
              className={`flex flex-col lg:flex-row items-center gap-12 ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className="flex-1">
                <div className="w-12 h-12 rounded-full bg-[#0056d7] flex items-center justify-center shadow-md mb-6">
                  {renderIcon(item.key)}
                </div>
                <h3 className="text-3xl font-semibold text-gray-900 mb-6">{item.title}</h3>
                <p className="text-lg text-gray-600 leading-relaxed">{item.description}</p>
              </div>
              
              <div className="flex-1 w-full max-w-2xl mx-auto lg:mx-0">
                <img 
                  src={item.image}
                  alt={item.title}
                  className="w-full h-auto lg:h-80 object-cover rounded-2xl shadow-lg transition-transform duration-700 hover:scale-105"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default RelationshipsSection;
